
  <div class="terminal">
    <pre>
Download Packages :
    npm i ngafr-authentication firebase firebaseui @angular/fire firebaseui-angular --save
AppModule :
    const firebaseConfig = &#123;
      apiKey: '*******',
      authDomain: '*******',
      databaseURL: '*******',
      projectId: '',
      storageBucket: '',
      messagingSenderId: '',
      appId: '',
      measurementId: ''
    &#125;;
    const authProviders: FirebaseAuthProviders =&#123;
      googleAuthProvider: true,
      emailAuthProvider: true,
      githubAuthProvider: false,
      facebookAuthProvider: false,
      AnonymousAuthProvider: false,
      phoneAuthProvider: false,
      twitterAuthProvider: false,
    &#125;;
    imports: [
      ...,
      NgafrAuthenticationModule
            .forRoot(firebaseConfig, authProviders),
      ...
    ]

Template :
    &lt;div
      ngafrAuth
      (userLoggedInEvent)="loggedInEvent($event)"
      (userEvent)="userEvent($event)"
      hideDefaultLogOutButton = "true"
      #ngafrAuth="ngafrAuth"&gt;
    &lt;/div&gt;
    &lt;button [disabled]="!loggedIn" (click)="ngafrAuth.logout()"&gt;Logout&lt;/button&gt;

Component :
    export class AuthDemoComponent &#123;
        public loggedIn = false;
        public userName = 'Guest';
        constructor() &#123;
        loggedInEvent($event) &#123;
            this.loggedIn = $event.isLoggedIn;
        &#125;
        userEvent($event) &#123;
            this.userName = 'Guest';
            if ($event && $event.user && $event.user.displayName)
                this.userName = $event.user.displayName;
        &#125;
    &#125;
    </pre>
</div>